import { render, staticRenderFns } from "./VirtualScrolling.vue?vue&type=template&id=3a648896&scoped=true"
import script from "./VirtualScrolling.vue?vue&type=script&lang=js"
export * from "./VirtualScrolling.vue?vue&type=script&lang=js"
import style0 from "./VirtualScrolling.vue?vue&type=style&index=0&id=3a648896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a648896",
  null
  
)

export default component.exports